export default __webpack_public_path__ + "static/media/water.74a92dad.png";